import { HYDRATE } from 'next-redux-wrapper';

const initialState = {};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case HYDRATE: {
			return { ...state, ...action.payload['home'] };
		}

		default:
			return state;
	}
};

export { reducer as home };

// export * from './selectors';
